import { expressSearch } from "@/libs/api.js";

export default {
	name: "logistics",
	data() {
		return {
			expressList: {},
			isShowInfo:false,
			isPolitCity:0,
			orderTag:'',
		};
	},
	created() {},
	mounted() {
		this.isPolitCity=this.$route.query.isPolitCity;
		this.orderTag=this.$route.query.orderTag;
		this.getExpres(this.$route.params.packageId);
		this.isShowInfo=this.isPolitCity!=1 && this.orderTag.includes('100008');

	},
	methods: {
		getExpres(packageId) {
			this.$toast.loading({
				duration: 0,
				mask: true,
				message: "加载中...",
			});
			let data = {
				packageNum: packageId,
				clientCallType: "H5",
			};
			expressSearch(data, "jsonCallback")
				.then((res) => {
					console.log(res);
					if (res.code === "0000" && res.data) {
						this.expressList = res.data;
					}
					this.$toast.clear();
				})
				.catch((error) => {
					this.$toast("查询失败哦！");
				});
		},
	},
};
